import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  bg: 'transparent',
  pl: ['10', null, '8'],
};
